module.exports = {
  "pageView": {
    "name": "pageview",
    "class": "view",
    "properties": {
      "screen": "string",
      "subscreen": "string"
    },
    "namespace": "settingsui"
  },
  "goalsInteraction": {
    "name": "Goals Interaction",
    "class": "interaction",
    "properties": {
      "action": [
        "update-goal",
        "goal-type-changed",
        "page view"
      ]
    },
    "namespace": "settingsui"
  },
  "createGoal": {
    "name": "Goals Create Goal",
    "class": "interaction",
    "properties": {
      "type": "string"
    },
    "namespace": "settingsui"
  },
  "changeGDPRSetting": {
    "name": "changed GDPR related setting",
    "class": "interaction",
    "properties": {
      "action": "string",
      "value": "boolean"
    },
    "namespace": "settingsui"
  },
  "editSSOConfig": {
    "name": "Edit SSO Configuration",
    "class": "interaction",
    "properties": {
      "action": "string",
      "error": {
        "type": "string",
        "isOptional": true
      },
      "modal": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "settingsui"
  },
  "addCurrency": {
    "name": "Add currency",
    "class": "interaction",
    "properties": {
      "action": "string",
      "screen": "string",
      "subscreen": "string"
    },
    "namespace": "settingsui"
  },
  "archiveCurrency": {
    "name": "Archive currency",
    "class": "interaction",
    "properties": {
      "action": "string",
      "screen": "string",
      "subscreen": "string"
    },
    "namespace": "settingsui"
  },
  "editCurrency": {
    "name": "Edit currency",
    "class": "interaction",
    "properties": {
      "action": "string",
      "screen": "string",
      "subscreen": "string"
    },
    "namespace": "settingsui"
  },
  "viewEspConnectModal": {
    "name": "view-esp-connect-modal",
    "class": "interaction",
    "namespace": "settingsui"
  },
  "clickUpdateDomainPrimaryLanguage": {
    "name": "click-update-primary-domain-language",
    "class": "interaction",
    "namespace": "settingsui"
  },
  "clickUpdatePageUrl": {
    "name": "click-update-page-url",
    "class": "interaction",
    "namespace": "settingsui"
  },
  "createAnalyticsView": {
    "name": "configured analytics view",
    "class": "interaction",
    "properties": {
      "action": "string",
      "usesDomainFilter": {
        "type": "boolean",
        "isOptional": true
      },
      "usesCountryFilter": {
        "type": "boolean",
        "isOptional": true
      },
      "usesURLFilter": {
        "type": "boolean",
        "isOptional": true
      },
      "usesURLPathAndQueryFilter": {
        "type": "boolean",
        "isOptional": true
      },
      "usesFQDNFilter": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "settingsui"
  },
  "editAnalyticsView": {
    "name": "configured analytics view",
    "class": "interaction",
    "properties": {
      "action": "string",
      "usesDomainFilter": {
        "type": "boolean",
        "isOptional": true
      },
      "usesCountryFilter": {
        "type": "boolean",
        "isOptional": true
      },
      "usesURLFilter": {
        "type": "boolean",
        "isOptional": true
      },
      "usesURLPathAndQueryFilter": {
        "type": "boolean",
        "isOptional": true
      },
      "usesFQDNFilter": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "settingsui"
  },
  "deleteAnalyticsView": {
    "name": "configured analytics view",
    "class": "interaction",
    "properties": {
      "action": "string"
    },
    "namespace": "settingsui"
  },
  "permanentlyDeleteAnalyticsView": {
    "name": "configured analytics view",
    "class": "interaction",
    "properties": {
      "action": "string"
    },
    "namespace": "settingsui"
  },
  "restoreAnalyticsView": {
    "name": "configured analytics view",
    "class": "interaction",
    "properties": {
      "action": "string"
    },
    "namespace": "settingsui"
  },
  "subscriptionTypeInteraction": {
    "name": "subscription type interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "internal": {
        "type": "boolean",
        "isOptional": true
      },
      "language": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "settingsui"
  },
  "doubleOptInInteraction": {
    "name": "double opt-in interaction",
    "class": "interaction",
    "properties": {
      "action": "string"
    },
    "namespace": "settingsui"
  },
  "sendFrequencyActivation": {
    "name": "send frequency activation",
    "class": "activation",
    "properties": {
      "status": {
        "type": "boolean"
      }
    },
    "namespace": "settingsui"
  },
  "sendFrequencyInteraction": {
    "name": "send frequency update",
    "class": "interaction",
    "properties": {
      "limit": {
        "isOptional": true,
        "type": "number"
      },
      "period": {
        "isOptional": true,
        "type": "string"
      }
    },
    "namespace": "settingsui"
  },
  "chooseEmailTemplateType": {
    "name": "choose email template type",
    "class": "interaction",
    "properties": {
      "action": "string",
      "emailType": "string",
      "isDragDrop": "boolean"
    },
    "namespace": "settingsui"
  },
  "activation": {
    "name": "Meetings activation rate",
    "class": "activation",
    "properties": {
      "step": [
        "clicked connect",
        "successful connection",
        "view zero state",
        "change connected calendar",
        "availability",
        "questions",
        "book meeting"
      ],
      "type": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "settingsui"
  },
  "leadScoreBanner": {
    "name": "lead score",
    "class": "interaction",
    "properties": {
      "action": "string"
    },
    "namespace": "settingsui"
  },
  "navigateToEcommerceIntegrations": {
    "name": "navigated to ecommerce integrations in directory",
    "class": "interaction",
    "namespace": "settingsui"
  },
  "ecommerceGetStartedClick": {
    "name": "ecommerce get started click",
    "class": "interaction",
    "properties": {
      "type": "string"
    },
    "namespace": "settingsui"
  },
  "ecommerceLinkInteraction": {
    "name": "ecommerce link interaction",
    "class": "interaction",
    "properties": {
      "link": "string"
    },
    "namespace": "settingsui"
  },
  "ecommerceTourTime": {
    "name": "ecommerce tour time",
    "class": "interaction",
    "properties": {
      "tour": "string",
      "step": "string",
      "time": "number"
    },
    "namespace": "settingsui"
  },
  "inheritanceToggleClicked": {
    "name": "Toggled field inheritance",
    "class": "interaction",
    "properties": {
      "subscreen2": "string",
      "settingsField": "string",
      "useInheritedDomainSettings": "boolean"
    },
    "namespace": "settingsui"
  },
  "blogSubscriptionEmailToggleClicked": {
    "name": "Blog subscription email toggle clicked",
    "class": "interaction",
    "properties": {
      "emailType": "string",
      "isEnabled": "boolean"
    },
    "namespace": "settingsui"
  },
  "websiteNavigationInteraction": {
    "name": "website navigation interaction",
    "class": "interaction",
    "properties": {
      "action": [
        "clicked-edit-blog-templates-link",
        "clicked-edit-system-templates-link",
        "clicked-view-blog-link",
        "clicked-edit-stylesheet-link"
      ]
    },
    "namespace": "settingsui"
  },
  "toggleEmailLessFormSubmission": {
    "namespace": "ads",
    "name": "Toggled emailless form submissions",
    "class": "interaction",
    "properties": {
      "allowEmailLessFormSubmissions": "boolean"
    }
  },
  "networkConnectSuccess": {
    "name": "Network Connect Success",
    "class": "interaction",
    "properties": {
      "network": "string",
      "connected": "number"
    },
    "namespace": "ads"
  },
  "networkConnectFailure": {
    "name": "Network Connect Failure",
    "class": "interaction",
    "properties": {
      "network": "string"
    },
    "namespace": "ads"
  },
  "accountConnectSuccess": {
    "name": "Account Connect Success",
    "class": "interaction",
    "properties": {
      "network": "string",
      "available": "number",
      "selected": "number",
      "tracked": "number"
    },
    "namespace": "ads"
  },
  "accountConnectFailure": {
    "name": "Account Connect Failure",
    "class": "interaction",
    "properties": {
      "network": "string"
    },
    "namespace": "ads"
  },
  "leadSyncConnect": {
    "name": "Lead Sync Connect",
    "class": "interaction",
    "properties": {
      "network": "string",
      "available": "number",
      "selected": "number"
    },
    "namespace": "ads"
  },
  "leadSyncDisconnect": {
    "name": "Lead Sync Disconnect",
    "class": "interaction",
    "properties": {
      "network": "string",
      "removed": "number"
    },
    "namespace": "ads"
  },
  "modifyPixel": {
    "name": "Modify pixel",
    "class": "usage",
    "properties": {
      "action": [
        "Install pixel",
        "Create pixel",
        "Opened install pixel modal"
      ],
      "network": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "ads"
  },
  "errorDisplay": {
    "name": "Error display",
    "class": "view",
    "properties": {
      "type": [
        "permissions",
        "inactive"
      ],
      "form": [
        "banner",
        "tooltip"
      ]
    },
    "namespace": "ads"
  },
  "errorAction": {
    "name": "Error action",
    "class": "interaction",
    "properties": {
      "type": [
        "permissions",
        "inactive"
      ],
      "action": [
        "clicked kb link"
      ]
    },
    "namespace": "ads"
  },
  "wizard-view": {
    "name": "wizard-view",
    "class": "view",
    "properties": {
      "action": "string",
      "screen": "string",
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "what_value_str": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "inbox-connect-utils"
  },
  "wizard-interaction": {
    "name": "wizard-interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "subAction": {
        "type": "string",
        "isOptional": true
      },
      "screen": "string",
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "what_value_str": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "inbox-connect-utils"
  },
  "fileManagerSetPanelExploreFiles": {
    "name": "Explore Files",
    "class": "interaction",
    "version": "v2",
    "properties": {
      "action": "string",
      "panel": "string"
    },
    "namespace": "file-picker"
  },
  "fileManagerExploreFiles": {
    "name": "Explore Files",
    "class": "interaction",
    "version": "v2",
    "properties": {
      "action": "string"
    },
    "namespace": "file-picker"
  },
  "fileManagerSelectOrDeselectExploreFiles": {
    "name": "Explore Files",
    "class": "interaction",
    "version": "v2",
    "properties": {
      "action": "string",
      "target": "string"
    },
    "namespace": "file-picker"
  },
  "fileManagerManageFiles": {
    "name": "Manage Files",
    "class": "interaction",
    "version": "v2",
    "properties": {
      "action": "string",
      "target": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "file-picker"
  },
  "fileManagerBrowseShutterstock": {
    "name": "Browse Shutterstock",
    "class": "interaction",
    "version": "v2",
    "properties": {
      "action": "string"
    },
    "namespace": "file-picker"
  },
  "fileManagerAcceptVideoTOS": {
    "name": "Accept Video TOS",
    "class": "interaction",
    "version": "v2",
    "properties": {
      "action": "boolean"
    },
    "namespace": "file-picker"
  },
  "settingsNavPageView": {
    "name": "pageview",
    "class": "view",
    "properties": {
      "screen": "string",
      "subscreen": "string",
      "subscreen2": "string"
    },
    "namespace": "settingsui"
  },
  "settingsNavInteraction": {
    "name": "settings-navigation",
    "class": "interaction",
    "properties": {
      "settingsGroup": "string",
      "settingsLink": "string",
      "settingsApp": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "settingsui"
  },
  "susShopifyInstalled": {
    "name": "Shopify installed",
    "class": "usage",
    "namespace": "settingsui"
  },
  "susIntegrationDisconnected": {
    "name": "integration-uninstalled",
    "class": "usage",
    "properties": {
      "what_value": "number"
    },
    "namespace": "settingsui"
  },
  "sulSettingsSave": {
    "name": "settings-save",
    "class": "interaction",
    "namespace": "settingsui"
  },
  "sulSettingsCancel": {
    "name": "settings-cancel",
    "class": "interaction",
    "namespace": "settingsui"
  },
  "sulSettingsEdit": {
    "name": "settings-edit",
    "class": "interaction",
    "properties": {
      "settingId": "string",
      "interaction": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "settingsui"
  }
};